const apis = {
  apiTip: '创建 API key 满足您的交易需求。为保障资产安全，请不要泄露您的 API key。',
  cjapi: '创建API',
  bzm: '备注名',
  qx: '权限',
  cjrq: '创建日期',
  cz: '操作',
  ck: '查看',
  bj: '编辑',
  sc: '删除',
  mm: '密码 (Passphrase)',
  qsrmm: '请输入密码 (Passphrase)',
  sjyzm: '手机验证码',
  qsryzm: '请输入验证码',
  yxyzm: '邮箱验证码',
  dzbmd: 'IP 地址白名单 (可选)',
  my: '秘钥',
  cancel: '取 消',
  confirm: '确 定',
  fzapi: '复制API信息',
  qdsc: '要删除 {name} API 吗？',
  tip: '提示',
  sccg: '删除成功!',
  yqxsc: '已取消删除',
  tips: '注：',
  zdcy: '每个主账户和子账户最多可持有 50 个活跃 API key。',
  qwxl: '请不要泄漏您的 API key；为 API key 绑定 IP 可以有效提高安全性。',
  dsfbd: '将拥有交易和提币权限的 API 与第三方平台绑定，可能会导致 API 信息泄露，请谨慎操作。',
  zdsc: '为了您的资金安全，未绑定 IP 地址且拥有交易或提币权限的 API key，将在闲置 14 天之后自动删除，需重新申请。已绑定 IP 或仅拥有读取权限的 API key 无有效期限制。',
  dq: '读取',
  jy: '交易',
  ljcj: '立即创建',
  qsrbzm: '请输入备注名',
  cjcg: '创建成功',
  czapi: '重置API',
  cjlc: '点击创建 API key > 创建属于自己的 API key 等信息 > 查看 API 文档详情 > 进行开发交易',
  zdbddz: '每个 API key 最多绑定 20 个 IP 地址，添加多个 IP 地址请用半角逗号分隔。',
  xgcg: '修改成功',

}
  export {
    apis
  }


// WEBPACK FOOTER //
// ./src/i18n/lang/api/zh.js